export const CONTACT_SALES_MAILTO =
  'mailto:sales@hiresuper.com' +
  '?subject=' +
  encodeURIComponent('Custom plan inquiry — onboarding pricing screen') +
  '&body=' +
  encodeURIComponent(
    "Hi Super team,\n\nI'm on the onboarding pricing screen and my projected volume is beyond your published bundles. Could we set up a custom plan?\n\nA quick note on my usage (calls, SMS, doors, timing) — [please add]\n\nThanks!\n\n— Sent from /onboarding/plan",
  )
